export default __webpack_public_path__ + "static/media/Trash.03668912.svg";